// Navbar
export const NAVBAR_HEIGHT = '64px';
export const NAVBAR_HEIGHT_MOBILE = '56px';

// Sidebar
export const SIDEBAR_WIDTH = '340px'; // 340px
export const SIDEBAR_BORDER_SIZE = '1px';
export const COLLAPSED_SIDEBAR_WIDTH = 'calc(64px + 1px)';
export const EXPANDED_SIDEBAR_WIDTH = 'calc(280px + 1px)';
export const EXPANDED_MOBILE_SIDEBAR_WIDTH = '70%';
/* Sidebar will collapse automatically on resize: */
export const SIDEBAR_AUTO_COLLAPSE_WIDTH = '1200px'; // 1200px / 75rem
export const SIDEBAR_AUTO_COLLAPSE_VALUE = 1200; // For JS calculations

// Input Manager/Viewer
export const TOOLBAR_HEIGHT = '70px';
export const FILTER_PANEL_WIDTH = '280px';
export const GALLERY_WIDTH = '3.75rem'; // 60px
export const MODES_HEIGHT = '3.75rem'; // 60px

// Page Layout
export const PAGE_CONTENT_MAX_WIDTH = '1280px';
export const PAGE_MAX_WIDTH_EXPANDED = `calc(100vw - ${SIDEBAR_WIDTH})`;
export const PAGE_MAX_WIDTH_COLLAPSED = `calc(100vw - ${COLLAPSED_SIDEBAR_WIDTH})`;
export const FORM_MAX_WIDTH = '800px';
export const PAGE_GUTTER_PADDING = '24px';
export const PAGE_TOP_PADDING = '40px';
export const PAGE_BOTTOM_PADDING = '80px';
export const EXPLORE_CONTENT_MAX_WIDTH = '1160px';

// Playground Header
export const PLAYGROUND_HEADER_HEIGHT = '72px';
